import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.navbar');
import { OnInit, OnDestroy, ChangeDetectorRef as CDR } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { IUser } from '../@types';
import { filter } from 'rxjs/operators';

declare let wiz: any;

const AUTO_LOGIN_KEY = 'inspectpro.login.auto';
const ACTIVE_SYNC_STATUSES = ['pending', 'syncing', 'failed'];

@Component({
    selector: 'wiz-layout-navbar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.navbar/view.scss */
body {
  width: 100%;
}

.navbar-light {
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  padding: 12px 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

main.no-navbar {
  padding-top: 0;
}

.user-info {
  padding: 8px 12px;
  border-radius: 12px;
  transition: all 0.2s;
}
.user-info:hover {
  background: #f1f5f9;
}

.logout-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #64748b;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;
}

.diagnostics-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #334155;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s;
}
.diagnostics-btn:hover {
  background: #eef2ff;
  border-color: #c7d2fe;
  color: #3730a3;
}

.network-status-wrap {
  position: relative;
}

.network-status-badge {
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 9px;
  border: 0;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
  cursor: pointer;
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}
.network-status-badge.online {
  background: #dcfce7;
  color: #15803d;
}
.network-status-badge.syncing {
  background: #fef3c7;
  color: #92400e;
}
.network-status-badge.offline {
  background: #fee2e2;
  color: #b91c1c;
}
.network-status-badge:hover {
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.14);
}
.network-status-badge:active {
  transform: translateY(1px);
}

.network-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  flex: 0 0 auto;
}
.network-dot.online {
  background: #22c55e;
}
.network-dot.syncing {
  background: #eab308;
}
.network-dot.offline {
  background: #ef4444;
}

.sync-count-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 20px;
  padding: 0 7px;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid rgba(185, 28, 28, 0.18);
  color: #991b1b;
  font-size: 11px;
  font-weight: 900;
  white-space: nowrap;
}
.sync-count-label.danger {
  background: #fee2e2;
  border-color: rgba(185, 28, 28, 0.28);
}

.sync-chevron {
  font-size: 10px;
  transition: transform 0.15s ease;
}
.sync-chevron.open {
  transform: rotate(180deg);
}

.sync-detail-panel {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  width: min(360px, 100vw - 32px);
  padding: 14px;
  border: 1px solid #dbe2ea;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.16);
  color: #0f172a;
  z-index: 200;
}

.sync-detail-header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.sync-detail-header strong,
.sync-detail-header span {
  display: block;
}
.sync-detail-header strong {
  font-size: 15px;
  font-weight: 900;
  line-height: 1.25;
}
.sync-detail-header span {
  margin-top: 3px;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
}

.sync-detail-close {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border: 0;
  border-radius: 8px;
  background: #f1f5f9;
  color: #475569;
  cursor: pointer;
}
.sync-detail-close:hover {
  background: #e2e8f0;
  color: #0f172a;
}

.sync-loading,
.sync-empty {
  min-height: 64px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
}
.sync-loading i,
.sync-empty i {
  color: #2563eb;
}

.sync-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sync-row {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}
.sync-row.pending {
  border-color: #bfdbfe;
  background: #f8fbff;
}
.sync-row.syncing {
  border-color: #fde68a;
  background: #fffdf5;
}
.sync-row.failed {
  border-color: #fecaca;
  background: #fffafa;
}

.sync-row-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #dbeafe;
  color: #2563eb;
  font-size: 12px;
}
.failed .sync-row-icon {
  background: #fee2e2;
  color: #b91c1c;
}
.syncing .sync-row-icon {
  background: #fef3c7;
  color: #92400e;
}

.sync-row-body {
  min-width: 0;
}
.sync-row-body strong,
.sync-row-body span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sync-row-body strong {
  font-size: 13px;
  font-weight: 900;
  line-height: 1.25;
}
.sync-row-body span {
  margin-top: 2px;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
}

.sync-row-status {
  min-width: 44px;
  padding: 3px 7px;
  border-radius: 999px;
  background: #dbeafe;
  color: #2563eb;
  text-align: center;
  font-size: 11px;
  font-weight: 900;
  white-space: nowrap;
}
.failed .sync-row-status {
  background: #fee2e2;
  color: #b91c1c;
}
.syncing .sync-row-status {
  background: #fef3c7;
  color: #92400e;
}

.sync-more {
  padding: 5px 10px;
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.sync-detail-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 14px;
}

.sync-action {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #475569;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
}
.sync-action.primary {
  border-color: #2563eb;
  background: #2563eb;
  color: #ffffff;
}
.sync-action:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.cached-session-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 999px;
  background: #eef2ff;
  color: #3730a3;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.cached-session-chip i {
  color: #4f46e5;
  font-size: 11px;
}

button, .cursor-pointer {
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

@media (max-width: 1024px) {
  .navbar-light {
    padding: 10px 16px;
  }
  .network-status-badge {
    padding: 5px 8px;
  }
  .sync-count-label {
    padding: 0 6px;
  }
}
@media (max-width: 860px) {
  .user-info .text-right,
  .cached-session-chip span {
    display: none;
  }
  .sync-detail-panel {
    right: -72px;
  }
}`],
})
export class LayoutNavbarComponent implements OnInit, OnDestroy {
    public user: IUser | null = null;
    public isMinimal: boolean = false;
    public networkStatus: string = 'online';
    public pendingSync: number = 0;
    public failedSync: number = 0;
    public syncingSync: number = 0;
    public syncQueueItems: any[] = [];
    public syncDetailOpen: boolean = false;
    public syncDetailLoading: boolean = false;
    public sessionMode: 'server' | 'cache' = 'server';

    private _unsubNetwork: (() => void) | null = null;
    private _unsubSync: (() => void) | null = null;
    private syncRefreshSeq: number = 0;

    constructor(@Inject( Service)         public service: Service,@Inject( CDR)         public ref: CDR,@Inject( Router    )         public router: Router    ) { }

    public async ngOnInit() {
        await this.service.init(this);
        this.service.trigger.bind('render', () => {
            this.ref.detectChanges();
        });

        this.checkMinimalMode();
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.checkMinimalMode();
            this.syncDetailOpen = false;
        });

        // Network status monitoring
        this.networkStatus = wiz.offline.network.status;
        this._unsubNetwork = wiz.offline.network.onStatusChange((status: string) => {
            this.networkStatus = status;
            if (status === 'online' || status === 'syncing') this.refreshSyncQueue(false);
            this.ref.detectChanges();
        });

        // Sync queue monitoring
        this._unsubSync = wiz.offline.sync.onPendingChange((count: number) => {
            this.pendingSync = count;
            this.refreshSyncQueue(false);
            this.ref.detectChanges();
        });

        try {
            if (!this.service.auth.allow(true)) {
                this.router.navigateByUrl('/login');
                return;
            }
            await this.loadSession();
            this.pendingSync = await wiz.offline.pendingSync();
            await this.refreshSyncQueue(false);
        } catch (e) {
            console.error('Navbar session load error:', e);
        } finally {
            await this.service.loading.hide();
        }
        this.ref.detectChanges();
    }

    public ngOnDestroy() {
        if (this._unsubNetwork) this._unsubNetwork();
        if (this._unsubSync) this._unsubSync();
    }

    private checkMinimalMode() {
        const url = this.router.url;
        this.isMinimal = url.includes('/project/detail') || url.includes('/inspection/facility');
        this.ref.detectChanges();
    }

    public async loadSession() {
        const { code, data } = await wiz.call('session');
        if (code !== 200) {
            if (wiz.offline.isOffline()) return;
            this.router.navigateByUrl('/login');
            return;
        }
        this.user = data;
        this.sessionMode = data && (data.offline === true || data.auth_mode === 'cache') ? 'cache' : 'server';
        this.ref.detectChanges();
    }

    public async logout() {
        await wiz.call('logout');
        try {
            localStorage.removeItem(AUTO_LOGIN_KEY);
            if (wiz.offline && wiz.offline.storage) {
                await wiz.offline.storage.clear('auth');
            }
        } catch (error) {
            console.error('Failed to clear auto login preference:', error);
        }
        this.router.navigateByUrl('/login');
    }

    public async toggleSyncDetails(event?: Event) {
        if (event) event.stopPropagation();
        this.syncDetailOpen = !this.syncDetailOpen;
        if (this.syncDetailOpen) await this.refreshSyncQueue(true);
        this.ref.detectChanges();
    }

    public closeSyncDetails(event?: Event) {
        if (event) event.stopPropagation();
        this.syncDetailOpen = false;
        this.ref.detectChanges();
    }

    public async forceSync(event?: Event) {
        if (event) event.stopPropagation();
        if (!wiz.offline.isOnline()) {
            this.syncDetailOpen = true;
            await this.refreshSyncQueue(true);
            return;
        }

        const result = await wiz.offline.forcSync();
        await this.refreshSyncQueue(false);
        if (result.success > 0 || result.failed > 0) {
            this.service.alert.show({
                title: result.failed > 0 ? '동기화 확인 필요' : '동기화 완료',
                message: `성공 ${result.success || 0}건, 실패 ${result.failed || 0}건`,
                status: result.failed > 0 ? 'warning' : 'success',
                action: '확인'
            });
        }
    }

    public openDiagnostics(event?: Event) {
        if (event) event.stopPropagation();
        this.router.navigateByUrl('/release/diagnostics');
    }

    public getNetworkStatusLabel(): string {
        if (this.networkStatus === 'online') return '온라인';
        if (this.networkStatus === 'syncing') return '동기화 중';
        return '오프라인';
    }

    public hasSyncQueueItems(): boolean {
        return this.syncQueueItems.length > 0;
    }

    public canRunSync(): boolean {
        return this.hasSyncQueueItems() && wiz.offline.isOnline();
    }

    public getSyncQueuePreview(): any[] {
        return this.syncQueueItems.slice(0, 5);
    }

    public getHiddenSyncCount(): number {
        return Math.max(0, this.syncQueueItems.length - this.getSyncQueuePreview().length);
    }

    public getSyncPanelTitle(): string {
        if (this.failedSync > 0) return `동기화 확인 ${this.failedSync}건`;
        if (this.pendingSync > 0) return `동기화 대기 ${this.pendingSync}건`;
        if (this.syncingSync > 0) return '동기화 진행 중';
        return '동기화 대기 없음';
    }

    public getSyncPanelDescription(): string {
        if (this.failedSync > 0) return '서버 반영에 실패한 작업이 있습니다. 온라인 상태에서 다시 동기화하세요.';
        if (this.pendingSync > 0) return '오프라인 저장/제출 작업이 서버 반영을 기다리고 있습니다.';
        if (this.syncingSync > 0) return '저장한 작업을 서버에 반영하는 중입니다.';
        return '현재 서버 반영을 기다리는 저장/제출 작업이 없습니다.';
    }

    public getSyncItemLabel(item: any): string {
        const entityType = String(item?.entity_type || '');
        const action = String(item?.action || '');
        if (entityType === 'checklist_response' && action === 'submit_response') return '체크리스트 제출';
        if (entityType === 'checklist_response' && action === 'save_response') return '체크리스트 저장';
        if (entityType === 'inspection_save') return '도면 점검 저장';
        if (action.includes('submit')) return '제출 작업';
        if (action.includes('save')) return '저장 작업';
        return entityType || action || '오프라인 작업';
    }

    public getSyncItemDescription(item: any): string {
        const id = item?.entity_id ? `ID ${item.entity_id}` : '로컬 작업';
        const updatedAt = this.formatSyncTime(item?.updated_at || item?.created_at);
        return updatedAt ? `${id} · ${updatedAt}` : id;
    }

    public getSyncItemStatusLabel(status: string): string {
        if (status === 'syncing') return '동기화 중';
        if (status === 'failed') return '실패';
        return '대기';
    }

    public queueStatusClass(item: any): string {
        const status = String(item?.status || 'pending');
        if (status === 'failed') return 'failed';
        if (status === 'syncing') return 'syncing';
        return 'pending';
    }

    private async refreshSyncQueue(showLoading: boolean = false) {
        const seq = ++this.syncRefreshSeq;
        if (showLoading) this.syncDetailLoading = true;
        try {
            const storage = wiz?.offline?.storage;
            let items: any[] = [];
            if (storage && typeof storage.getSyncQueueItems === 'function') {
                items = await storage.getSyncQueueItems();
            } else if (storage && typeof storage.getAll === 'function') {
                items = await storage.getAll('sync_queue');
            }
            if (seq !== this.syncRefreshSeq) return;

            const activeItems = (Array.isArray(items) ? items : [])
                .filter((item: any) => ACTIVE_SYNC_STATUSES.includes(String(item?.status || 'pending')))
                .sort((a: any, b: any) => Number(a?.created_at || 0) - Number(b?.created_at || 0));

            this.syncQueueItems = activeItems;
            this.pendingSync = activeItems.filter((item: any) => String(item?.status || 'pending') === 'pending').length;
            this.failedSync = activeItems.filter((item: any) => String(item?.status || '') === 'failed').length;
            this.syncingSync = activeItems.filter((item: any) => String(item?.status || '') === 'syncing').length;
        } catch (error) {
            console.error('Failed to load sync queue:', error);
        } finally {
            if (seq === this.syncRefreshSeq) this.syncDetailLoading = false;
            this.ref.detectChanges();
        }
    }

    private formatSyncTime(value: any): string {
        if (!value) return '';
        const date = new Date(typeof value === 'number' ? value : String(value));
        if (Number.isNaN(date.getTime())) return '';
        return date.toLocaleString('ko-KR', {
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    }
}

export default LayoutNavbarComponent;